var _defs, _g, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystationPlusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs388"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g294"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus_Shape",
    transform: "translate(-250.00018,-251.88485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_D_Sides"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.31317,
    y1: 535.93188,
    x2: 723.61932,
    y2: 588.09113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D39D04"
    },
    id: "stop296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    style: {
      stopColor: "#C06C11"
    },
    id: "stop298"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "m 742.025,534.652 c -0.448,0.207 -0.914,0.389 -1.394,0.542 -0.478,0.155 -0.973,0.281 -1.48,0.384 -0.51,0.103 -1.032,0.179 -1.571,0.226 l -108.458,9.357 -68.506,44.893 104.457,-10.128 c 0.519,-0.052 1.026,-0.128 1.516,-0.231 0.492,-0.103 0.97,-0.232 1.437,-0.387 0.463,-0.15 0.915,-0.328 1.346,-0.53 0.436,-0.199 0.856,-0.424 1.26,-0.669 24.231,-14.712 48.459,-29.428 72.69,-44.141 -0.42,0.25 -0.851,0.479 -1.297,0.684 z",
    id: "path301"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.95679,
    y1: 335.86069,
    x2: 451.75421,
    y2: 371.0921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D39D04"
    },
    id: "stop303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    style: {
      stopColor: "#C06C11"
    },
    id: "stop305"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "m 415.692,271.683 c -0.332,-1.474 -0.49,-2.908 -0.494,-4.289 -0.004,-1.378 0.151,-2.7 0.451,-3.95 0.296,-1.249 0.74,-2.423 1.314,-3.507 0.57,-1.085 1.275,-2.078 2.094,-2.962 -18.813,20.329 -37.625,40.655 -56.435,60.984 -0.796,0.859 -1.476,1.816 -2.038,2.861 -0.558,1.045 -0.994,2.173 -1.295,3.371 -0.301,1.197 -0.462,2.464 -0.475,3.78 -0.012,1.316 0.127,2.685 0.428,4.086 l 25.043,116.694 58.975,-54.323 z",
    id: "path308"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.04739,
    y1: 630.12219,
    x2: 644.5177,
    y2: 716.19031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D39D04"
    },
    id: "stop310"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    style: {
      stopColor: "#C06C11"
    },
    id: "stop312"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "m 651.305,694.852 c -0.404,0.167 -0.815,0.317 -1.24,0.451 -0.423,0.131 -0.859,0.246 -1.298,0.345 -0.443,0.094 -0.894,0.174 -1.357,0.232 l -113.054,14.583 c -2.688,0.347 -5.387,0.071 -7.968,-0.733 -2.585,-0.8 -5.051,-2.125 -7.267,-3.867 -2.213,-1.746 -4.175,-3.911 -5.755,-6.39 -1.576,-2.477 -2.77,-5.271 -3.444,-8.272 l -29.911,-133.173 -62.427,45.89 27.042,126.008 c 0.61,2.838 1.714,5.47 3.194,7.806 1.477,2.331 3.325,4.365 5.423,5.995 2.094,1.635 4.437,2.866 6.895,3.602 2.458,0.736 5.035,0.973 7.608,0.627 l 108.435,-14.827 c 0.439,-0.06 0.876,-0.14 1.302,-0.234 0.424,-0.096 0.841,-0.211 1.251,-0.337 0.408,-0.13 0.803,-0.276 1.196,-0.44 0.387,-0.162 0.768,-0.34 1.135,-0.534 23.808,-12.429 47.613,-24.857 71.42,-37.284 -0.385,0.2 -0.776,0.387 -1.18,0.552 z",
    id: "path315"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.6104,
    y1: 489.38809,
    x2: 474.30191,
    y2: 573.71692
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D39D04"
    },
    id: "stop317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    style: {
      stopColor: "#C06C11"
    },
    id: "stop319"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "m 354.594,568.852 c -2.863,0.244 -5.721,-0.123 -8.437,-1.01 -2.719,-0.883 -5.292,-2.284 -7.584,-4.089 -2.294,-1.804 -4.302,-4.017 -5.894,-6.526 -1.587,-2.506 -2.754,-5.312 -3.366,-8.308 L 303.283,421.32 c -0.332,-1.626 -0.471,-3.217 -0.431,-4.752 0.038,-1.533 0.254,-3.009 0.63,-4.407 0.375,-1.397 0.912,-2.716 1.592,-3.938 0.681,-1.218 1.506,-2.339 2.461,-3.34 -17.65,18.53 -35.298,37.06 -52.949,55.587 -0.919,0.966 -1.716,2.04 -2.375,3.208 -0.661,1.17 -1.186,2.428 -1.558,3.762 -0.37,1.334 -0.589,2.738 -0.641,4.195 -0.052,1.461 0.067,2.968 0.368,4.513 l 23.552,120.773 c 0.552,2.831 1.637,5.475 3.125,7.834 1.488,2.363 3.378,4.436 5.543,6.122 2.163,1.688 4.599,2.981 7.178,3.793 2.577,0.807 5.297,1.132 8.026,0.867 l 119.781,-11.617 62.427,-45.89 z",
    id: "path322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.38531,
    y1: 398.49051,
    x2: 738.69061,
    y2: 555.10883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D39D04"
    },
    id: "stop325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    style: {
      stopColor: "#C06C11"
    },
    id: "stop327"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_5_)"
    },
    d: "m 697.873,383.72 c 2.295,-0.097 4.618,0.331 6.851,1.186 2.228,0.855 4.369,2.137 6.309,3.752 1.94,1.613 3.676,3.56 5.098,5.747 1.425,2.185 2.53,4.611 3.21,7.184 l 29.9,113.487 c 0.701,2.656 0.903,5.229 0.665,7.604 -0.234,2.378 -0.911,4.559 -1.959,6.435 -1.054,1.876 -2.486,3.447 -4.232,4.599 -1.75,1.157 -3.816,1.888 -6.135,2.09 l -108.458,9.357 31.336,127.538 c 0.704,2.87 0.871,5.672 0.569,8.276 -0.305,2.609 -1.076,5.027 -2.252,7.125 -1.181,2.097 -2.759,3.882 -4.675,5.221 -1.915,1.34 -4.168,2.237 -6.689,2.56 l -113.054,14.583 c -2.688,0.347 -5.387,0.071 -7.968,-0.733 -2.585,-0.8 -5.051,-2.125 -7.267,-3.867 -2.213,-1.746 -4.175,-3.911 -5.755,-6.39 -1.576,-2.477 -2.77,-5.271 -3.444,-8.272 L 480.012,558.029 354.594,568.851 c -2.863,0.244 -5.721,-0.123 -8.437,-1.01 -2.719,-0.883 -5.292,-2.284 -7.584,-4.089 -2.294,-1.804 -4.302,-4.017 -5.894,-6.526 -1.587,-2.506 -2.754,-5.312 -3.366,-8.308 L 303.283,421.32 c -0.589,-2.885 -0.569,-5.656 -0.033,-8.199 0.535,-2.539 1.589,-4.846 3.069,-6.808 1.478,-1.957 3.382,-3.569 5.624,-4.721 2.237,-1.15 4.809,-1.842 7.632,-1.961 L 443.26,394.43 415.692,271.684 c -0.601,-2.666 -0.641,-5.207 -0.198,-7.519 0.44,-2.307 1.358,-4.387 2.676,-6.134 1.318,-1.744 3.032,-3.155 5.067,-4.135 2.03,-0.978 4.381,-1.522 6.97,-1.534 l 109.24,-0.477 c 2.437,-0.01 4.884,0.497 7.223,1.423 2.331,0.926 4.559,2.268 6.558,3.934 1.999,1.662 3.772,3.649 5.206,5.858 1.432,2.209 2.521,4.643 3.149,7.207 l 28.978,117.927 z",
    id: "path330"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      enableBackground: "new"
    },
    id: "g366"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    style: {
      enableBackground: "new"
    },
    d: "m 697.873,383.72 c 2.295,-0.097 4.618,0.331 6.851,1.186 2.228,0.855 4.369,2.137 6.309,3.752 1.94,1.613 3.676,3.56 5.098,5.747 1.425,2.185 2.53,4.611 3.21,7.184 l 29.9,113.487 c 0.701,2.656 0.903,5.229 0.665,7.604 -0.234,2.378 -0.911,4.559 -1.959,6.435 -1.054,1.876 -2.486,3.447 -4.232,4.599 -1.75,1.157 -3.816,1.888 -6.135,2.09 l -108.458,9.357 31.336,127.538 c 0.704,2.87 0.871,5.672 0.569,8.276 -0.305,2.609 -1.076,5.027 -2.252,7.125 -1.181,2.097 -2.759,3.882 -4.675,5.221 -1.915,1.34 -4.168,2.237 -6.689,2.56 l -113.054,14.583 c -2.688,0.347 -5.387,0.071 -7.968,-0.733 -2.585,-0.8 -5.051,-2.125 -7.267,-3.867 -2.213,-1.746 -4.175,-3.911 -5.755,-6.39 -1.576,-2.477 -2.77,-5.271 -3.444,-8.272 L 480.012,558.029 354.594,568.851 c -2.863,0.244 -5.721,-0.123 -8.437,-1.01 -2.719,-0.883 -5.292,-2.284 -7.584,-4.089 -2.294,-1.804 -4.302,-4.017 -5.894,-6.526 -1.587,-2.506 -2.754,-5.312 -3.366,-8.308 L 303.283,421.32 c -0.589,-2.885 -0.569,-5.656 -0.033,-8.199 0.535,-2.539 1.589,-4.846 3.069,-6.808 1.478,-1.957 3.382,-3.569 5.624,-4.721 2.237,-1.15 4.809,-1.842 7.632,-1.961 L 443.26,394.43 415.692,271.684 c -0.601,-2.666 -0.641,-5.207 -0.198,-7.519 0.44,-2.307 1.358,-4.387 2.676,-6.134 1.318,-1.744 3.032,-3.155 5.067,-4.135 2.03,-0.978 4.381,-1.522 6.97,-1.534 l 109.24,-0.477 c 2.437,-0.01 4.884,0.497 7.223,1.423 2.331,0.926 4.559,2.268 6.558,3.934 1.999,1.662 3.772,3.649 5.206,5.858 1.432,2.209 2.521,4.643 3.149,7.207 l 28.978,117.927 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.38531,
    y1: 398.49051,
    x2: 738.69061,
    y2: 555.10883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    },
    id: "stop335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    },
    id: "stop337"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_6_)"
    },
    id: "use340"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    },
    id: "use342"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_7_)",
    id: "g364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g362"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs346"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_20_",
    points: "749.24,515.076 749.925,518.983 749.905,522.68 749.231,526.083 747.946,529.115         746.089,531.688 743.714,533.714 740.861,535.115 737.579,535.804 629.12,545.161 660.457,672.699 661.117,676.934         661.026,680.975 660.226,684.727 658.774,688.1 656.716,690.993 654.099,693.321 650.985,694.983 647.41,695.881         534.355,710.463 530.334,710.531 526.388,709.731 522.616,708.151 519.121,705.864 516.005,702.947 513.366,699.474         511.303,695.537 509.922,691.202 480.012,558.029 354.594,568.852 350.321,568.772 346.157,567.841 342.205,566.143         338.573,563.752 335.364,560.756 332.68,557.226 330.63,553.257 329.313,548.918 303.283,421.32 302.844,417.091         303.25,413.121 304.432,409.499 306.319,406.313 308.845,403.649 311.943,401.591 315.541,400.224 319.575,399.63         443.26,394.429 415.692,271.683 415.202,267.791 415.494,264.165 416.504,260.887 418.17,258.03 420.438,255.675         423.237,253.896 426.514,252.766 430.207,252.362 539.447,251.885 543.094,252.245 546.67,253.308 550.073,254.998         553.228,257.242 556.042,259.965 558.433,263.1 560.309,266.57 561.583,270.307 590.561,388.235 697.873,383.72         701.32,383.956 704.724,384.906 707.989,386.497 711.032,388.658 713.776,391.316 716.13,394.405 718.015,397.851         719.34,401.589 749.24,515.076       "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.84409,
    y1: 481.20789,
    x2: 749.92511,
    y2: 481.20789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    },
    id: "stop348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4242,
    style: {
      stopColor: "#000000"
    },
    id: "stop350"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_20_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_8_)"
    },
    id: "use353"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_20_",
    style: {
      overflow: "visible"
    },
    id: "use355"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_9_)",
    id: "g360"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 221,
    height: 227,
    transform: "matrix(2.0265,0,0,2.0265,302.8441,251.885)",
    id: "image358"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Face_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.04279,
    y1: 636.53339,
    x2: 642.11951,
    y2: 319.375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1636,
    style: {
      stopColor: "#FBF6C8"
    },
    id: "stop369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4848,
    style: {
      stopColor: "#FACC00"
    },
    id: "stop371"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Face_1_",
    style: {
      fill: "url(#Face_2_)"
    },
    d: "m 749.925,518.995 v -0.012 l -0.003,-0.017 c -0.108,-1.266 -0.333,-2.568 -0.682,-3.89 l -29.9,-113.487 c -0.34,-1.283 -0.785,-2.531 -1.324,-3.73 l -0.002,-0.008 -0.007,-0.01 c -0.537,-1.197 -1.167,-2.345 -1.878,-3.436 -1.421,-2.187 -3.158,-4.134 -5.098,-5.747 -0.96,-0.8 -1.97,-1.516 -3.016,-2.141 l -0.027,-0.02 -0.027,-0.012 c -1.047,-0.623 -2.132,-1.154 -3.238,-1.579 -1.117,-0.428 -2.257,-0.748 -3.404,-0.95 v 0 0 c -1.147,-0.202 -2.301,-0.283 -3.447,-0.236 L 590.56,388.234 561.582,270.307 c -0.628,-2.564 -1.718,-4.998 -3.149,-7.207 -0.716,-1.102 -1.516,-2.152 -2.388,-3.129 l -0.003,-0.006 -0.005,-0.006 c -0.871,-0.978 -1.812,-1.888 -2.809,-2.717 -1.999,-1.666 -4.227,-3.008 -6.558,-3.934 -1.169,-0.461 -2.361,-0.819 -3.567,-1.061 l -0.008,-0.002 h -0.005 c -1.208,-0.242 -2.427,-0.365 -3.643,-0.36 l -109.24,0.477 c -1.288,0.007 -2.52,0.145 -3.679,0.402 l -0.014,0.002 -0.01,0.002 c -1.162,0.261 -2.254,0.642 -3.267,1.128 -2.034,0.979 -3.749,2.391 -5.067,4.135 -1.318,1.747 -2.237,3.827 -2.676,6.134 -0.221,1.156 -0.322,2.37 -0.292,3.626 v 0 0 c 0.03,1.256 0.189,2.559 0.49,3.893 l 27.568,122.746 -123.685,5.201 c -2.823,0.119 -5.395,0.811 -7.632,1.961 -1.116,0.574 -2.147,1.261 -3.085,2.048 l -0.013,0.01 -0.01,0.012 c -0.938,0.79 -1.779,1.677 -2.515,2.652 -1.48,1.962 -2.534,4.269 -3.069,6.808 -0.268,1.269 -0.408,2.595 -0.404,3.964 l -0.002,0.006 v 0.004 c 0.002,1.371 0.144,2.784 0.439,4.225 l 26.031,127.598 c 0.305,1.492 0.749,2.932 1.31,4.318 l 0.006,0.02 0.01,0.015 c 0.566,1.386 1.25,2.708 2.04,3.954 0.793,1.255 1.693,2.43 2.678,3.523 l 0.006,0.007 0.01,0.008 c 0.984,1.088 2.056,2.09 3.2,2.988 2.292,1.805 4.865,3.206 7.584,4.089 2.716,0.887 5.574,1.255 8.437,1.01 l 125.418,-10.822 29.911,133.173 c 0.332,1.485 0.795,2.917 1.367,4.288 l 0.013,0.047 0.024,0.044 c 0.576,1.366 1.26,2.668 2.039,3.894 0.787,1.236 1.671,2.395 2.634,3.459 l 0.005,0.013 0.01,0.007 c 0.962,1.064 2.002,2.039 3.106,2.91 1.1,0.862 2.262,1.627 3.469,2.272 l 0.025,0.015 0.027,0.012 c 1.209,0.645 2.461,1.172 3.745,1.568 1.288,0.399 2.605,0.669 3.934,0.795 l 0.012,0.005 h 0.017 c 1.327,0.121 2.667,0.106 4.005,-0.067 l 113.054,-14.583 c 1.256,-0.162 2.445,-0.466 3.559,-0.894 l 0.017,-0.003 0.017,-0.012 c 1.11,-0.431 2.145,-0.985 3.097,-1.65 0.951,-0.665 1.819,-1.442 2.597,-2.307 l 0.02,-0.02 0.018,-0.029 c 0.773,-0.866 1.455,-1.827 2.039,-2.865 1.176,-2.098 1.947,-4.517 2.252,-7.125 0.301,-2.604 0.135,-5.406 -0.569,-8.276 L 629.12,545.161 737.578,535.804 c 2.319,-0.202 4.385,-0.933 6.135,-2.09 1.746,-1.152 3.178,-2.723 4.232,-4.599 0.522,-0.933 0.952,-1.943 1.28,-3.014 l 0.005,-0.017 0.005,-0.015 c 0.327,-1.073 0.552,-2.204 0.669,-3.388 0.119,-1.185 0.127,-2.42 0.021,-3.686 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d07500"
    },
    d: "m 445.983,520.009 -16.843,-85.965 -84,5.245 16.844,87.725 z m -26.866,-72.983 12.118,61.837 -59.231,4.938 -12.111,-63.077 z",
    id: "path375"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d07500"
    },
    d: "m 714.49,462.191 c -2.615,-24.888 -24.989,-45.136 -49.873,-45.136 -11.945,0 -22.695,4.631 -30.267,13.042 -7.634,8.478 -11.14,19.78 -9.874,31.823 2.615,24.888 24.989,45.135 49.873,45.135 11.945,0 22.695,-4.631 30.267,-13.042 7.634,-8.478 11.14,-19.779 9.874,-31.822 z m -18.962,23.642 c -5.222,5.8 -12.744,8.995 -21.179,8.995 -18.497,0 -35.767,-15.655 -37.714,-34.187 -0.898,-8.553 1.519,-16.495 6.802,-22.363 5.222,-5.801 12.744,-8.996 21.179,-8.996 18.497,0 35.767,15.655 37.714,34.187 0.898,8.554 -1.519,16.496 -6.802,22.364 z",
    id: "path377"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d07500"
    },
    points: "584.165,625.377 609.908,589.721 599.786,582.134 574.063,617.763 534.467,588.079 526.876,598.202 566.448,627.864 536.786,667.434 546.907,675.021 576.551,635.48 612.182,661.203 619.77,651.082 ",
    id: "polygon379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d07500"
    },
    d: "m 497.326,270.409 -38.196,92.424 99.347,-5.718 z m 42.725,77.073 -61.286,2.173 21.27,-56.435 z",
    id: "path381"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystationPlusLogo);
export default __webpack_public_path__ + "static/media/playstation-plus-logo.7c9cbc6027210c6f29494e4fec33de02.svg";
export { ForwardRef as ReactComponent };